<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_701_19903)">
      <path
        d="M14.8193 8.52344L13.8086 9.12695L13.8096 9.12793C13.3753 9.38781 12.6904 9.62722 12.1191 9.20703C11.5518 8.78964 11.5694 8.0677 11.6826 7.57422L11.9229 6.52344C11.9226 6.52225 11.9232 6.52079 11.9229 6.51953C11.9225 6.51824 11.9213 6.51674 11.9209 6.51562L11.0781 5.66602C10.7287 5.31373 10.4317 4.77439 10.6191 4.18262C10.8076 3.58818 11.3637 3.32076 11.8545 3.23828L12.9326 3.05664H12.9346L12.9355 3.05469L13.5381 1.84082L13.5391 1.83887C13.7602 1.39542 14.1805 0.916992 14.8203 0.916992C15.4608 0.917112 15.8791 1.39663 16.0986 1.84082H16.0996L16.7012 3.05469L16.7031 3.05664L17.7861 3.23828C18.2762 3.32064 18.8331 3.58763 19.0225 4.18164C19.2113 4.77403 18.9136 5.31253 18.5625 5.66504L18.5635 5.66602L17.7197 6.51562C17.7194 6.5167 17.7191 6.51828 17.7188 6.51953C17.7183 6.52128 17.7172 6.5228 17.7168 6.52441L17.958 7.57422C18.0703 8.06547 18.0914 8.78982 17.5225 9.20801C16.9505 9.62831 16.2654 9.38642 15.833 9.12891L15.832 9.12793L14.8193 8.52344ZM16.7168 3.08594L16.7197 3.09082C16.7185 3.08836 16.717 3.0862 16.7158 3.08398L16.7168 3.08594Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.56152 0.947266C7.8694 0.857148 8.20096 0.973096 8.38574 1.23535C8.57021 1.49755 8.56725 1.84797 8.37891 2.10742C7.56335 3.22995 7.08304 4.61066 7.08301 6.10547C7.08301 9.86627 10.1318 12.915 13.8926 12.915C15.3871 12.9149 16.7673 12.4345 17.8896 11.6191C18.1492 11.4305 18.5004 11.4275 18.7627 11.6123C19.025 11.7971 19.141 12.1286 19.0508 12.4365C17.925 16.2774 14.3755 19.0838 10.1689 19.084C5.05784 19.084 0.914062 14.9402 0.914062 9.8291C0.914099 5.62241 3.72057 2.0731 7.56152 0.947266Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_701_19903">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
